const sakésList = [
  { name: "Shochikubai", shot: "4", carafe: "9", bouteille: "-" },
  {
    name: "Kimoto (bouteille 64cl)",
    shot: "5",
    carafe: "12",
    bouteille: "36",
  },
  {
    name: "Homare Kirin",
    shot: "6",
    carafe: "18",
    bouteille: "39",
  },
  {
    name: "Kimoto Junmai (bouteille 64cl)",
    shot: "-",
    carafe: "12",
    bouteille: "36",
  },
  { name: "Kambbara", shot: "-", carafe: "18", bouteille: "52" },
  { name: "Tatenokawa", shot: "8", carafe: "19", bouteille: "54" },
  {
    name: "Pétillant Mio (bouteille 18cl)",
    shot: "-",
    carafe: "-",
    bouteille: "9",
  },
  { name: "Nabeshima", shot: "-", carafe: "-", bouteille: "59" },
  { name: "Rosé Caro", shot: "-", carafe: "-", bouteille: "66" },
  { name: "Hosho dimand dust", shot: "-", carafe: "-", bouteille: "68" },
  {
    name: "Kirin jijoshu vintage",
    shot: "-",
    carafe: "-",
    bouteille: "98",
  },
]

export default sakésList
